import React, { FC, memo, useMemo, useState, useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom'
import styled from 'styled-components';
import { Colors, FInter, FlexBox, useIsMobile } from '@brg/ui';
import { CreateLinkTo, LinkTo } from '../../constants/linkTo';
import ProjectCardLayoutNew from '../projectCard/projectCardLayoutNew';
import { ProjectEvents } from "../../helpers/projectEvents";
import { ProjectTooltipProps } from '../tooltips/ProjectTooltip';
import { getProjectImages } from "../../pages/project/sections/ps-image";
import { useTranslation } from "react-i18next";
import { AppTester } from 'supporting';
import { ComputedTeam } from 'shared/helpers/types/computed/ComputedTeam';
import {ModerationType} from "../../pages/teams/const/ModerationTypes";
import {ProjectCardTitle} from "../projectCard/styles";
import { LMSCourseDurationTypes } from 'shared/pages/teams/const/LMSCourseTypes';
import { TeamStatusActiveArchived } from 'shared/helpers/teamsStatus';

const Author = styled(FInter.SmallText)`
  font-size: 11px;
  line-height: 13px;
    
  color: ${Colors.geoWhite47};
  @media (max-width: 940px) {
    div {
      font-weight: 400;
    }
  }
`

export const StatusText = styled(FlexBox)<{hasCover?: boolean}>`
  position: absolute;
  top: 16px;
  left: 16px;
  margin-right: 100%;

  color: ${({ hasCover }) => hasCover ? '#fff' : '#909090'};
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
  font-family: 'Inter';
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 13px; /* 118.182% */
  white-space: nowrap;
`;

export interface ChannelCardProps extends Partial<ComputedTeam>, ProjectEvents {
  isLoading?: boolean;
  isEditable?: boolean;
  isSelectable?: boolean;
  isDeletable?: boolean;
  isRejected?: boolean;
  isRemovableFromBook?: boolean;
  tooltip?: ProjectTooltipProps;
  width?: string;
  height?: string;
  entityType?: string;
  onShouldReload?: (sender: any) => void;
  onTeamClick?: (team: ComputedTeam, e?: any) => void;
  onSelect?: (projectId: string) => void;
  onApprove?: (projectId: string) => void;
  onReject?: (projectId: string) => void;

  team?: ComputedTeam;
 
  isModal?: boolean;
  dataKey?: any;
  linkPrefix?: string;
  linkTo?: any;
}

const ChannelCard: FC<ChannelCardProps> = (props) => {
    const {
      isLoading,
      isSelectable,
      isDeletable,
      isRemovableFromBook,
      isEditable,
      isRejected,
      tooltip,
      width,
      height,
      onApprove,
      onReject,
      onSelect,
      onShouldReload,
      onTeamClick,
      onRemoveFromBook,
      team,
      contextName,
      linkPrefix,
      linkTo,
      entityType,
      ...handlers
    } = props;

    const { i18n } = useTranslation();
    const isOnlines = AppTester.isOnlines();
    const isMedia = AppTester.isMediiia();
    const [isBookmarked, setIsBookmarked] = useState<boolean>()
    const { t } = useTranslation();
    const isMobile = useIsMobile();
    const isTimeLine = !!useRouteMatch('/timeline');

    const [isTooltipOpen, setTooltipOpen] = useState<boolean>(false);

    const handleToolTipToggleMove = (val: boolean) => {
      setTooltipOpen && setTooltipOpen(val);
    }

    const titleImages = getProjectImages(team, i18n.language);

    useEffect(() => {
      if (!team) return;
      //@ts-ignore
      setIsBookmarked(team.isBookmark);
    }, [team]);
  
    const handleTeamClick = (projectId?: string, e?: any) => {
      team && onTeamClick && onTeamClick(team, e);
    }

    const lmsCardType = useMemo(() => {

      return undefined;
    }, [team, entityType]);

    const horizontalCover = useMemo(() => {
      //@ts-ignore
      return (team?.lmsCourseTerm === LMSCourseDurationTypes.short) /*|| (isUnitCourse && team?.lmsCourseTerm === null)*/
    } , [team])
    // @ts-ignore
    const teamOwner = useMemo(() => team?.owners?.length > 0 ? `${team?.owners[0]?.name} ${team?.owners[0]?.surName}` : '', [team])
    
    const isArchiveCourseChannel = useMemo(() => {
      return team?.moderationType === ModerationType.ChannelGroupOrCourse && TeamStatusActiveArchived(team)
    } , [team])

    const backgroundStyles = useMemo(() => {
      if (isArchiveCourseChannel) {
        return {
          background: 'linear-gradient( 180deg,rgba(0, 0, 0, 0),  rgba(24, 26, 28, 0), rgba(24, 26, 28, 0.85) )',
          backdropFilter: 'blur(2.5px)',
          marginTop: 0
        }
      }
      return undefined
    } , [isArchiveCourseChannel])


    const statusText = useMemo(() => {
      if (isArchiveCourseChannel) {
        return <StatusText hasCover={!!titleImages?.length}>{t('subscription.in_archive').toLowerCase()}</StatusText>
      }
      return undefined
    } , [isArchiveCourseChannel, titleImages])

    const title = useMemo(() => {

      if (isTimeLine) return null;

      //@ts-ignore
      else if (team?.coverTitle?.length) {
        //@ts-ignore
        return <ProjectCardTitle >{team?.coverTitle}</ProjectCardTitle>
      } 
      else if (team?.name?.length) {
        return <ProjectCardTitle {...(isArchiveCourseChannel ? { color: '#909090'} : {})}>{team?.name}</ProjectCardTitle>
      } else return null;


    }, [team, isTimeLine, isArchiveCourseChannel])

    const subscribersCount = useMemo(() => team?.subscribersCount , [team])

    const likes = useMemo(() => {

      if (team?.moderationType === ModerationType.ChannelGroupOrCourse || !subscribersCount || subscribersCount === 0) return null;

      return  (
        <Author>
          <span style={{ color: isMedia && isMobile ? '#151514' :'#fefefe' }}>{`Подписчиков: ${subscribersCount}`}</span>
        </Author>
      )
    } , [team, subscribersCount])

      return (
      <ProjectCardLayoutNew
        title={title}
        coverTitle={!!team?.name ? <ProjectCardTitle>{team?.name}</ProjectCardTitle> : undefined}
        identifier={team?.teamId}
        onClick={handleTeamClick}
        titleImages={titleImages}
        isLoading={isLoading}
        width={width}
        team={team}
        height={height}
        isMoreVisible={true}
        isRejected={isRejected}
        metaAlwaysVisible={false}
        tooltipOpen={isTooltipOpen}
        toggleTooltip={handleToolTipToggleMove}
        needLmsCover={horizontalCover}
        statusText={statusText}
        isMobileMoreVisible={isArchiveCourseChannel}
        backgroundStyles={backgroundStyles}
        linkTo={linkTo}
        // @ts-ignore
        projectType={lmsCardType}
        lmsCardType={lmsCardType}
        withoutGoToProject={!linkTo}
        author={
          (
            <Author>
              {/*@ts-ignore*/}
              <span style={{ color: isMedia && isMobile ? '#151514' :'#fefefe'}}>{teamOwner}</span>
            </Author>
          )
        }
        likes={likes}
        isTeam
      />
    );
  }
;

export default memo(ChannelCard);
import React, { FC, memo, useMemo, useState, useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom'
import styled from 'styled-components';
import { Colors, FInter, FlexBox, useIsMobile } from '@brg/ui';
import { CreateLinkTo, LinkTo } from '../../constants/linkTo';
import ProjectCardLayoutNew from '../projectCard/projectCardLayoutNew';
import { ProjectEvents } from "../../helpers/projectEvents";
import { ProjectTooltipProps } from '../tooltips/ProjectTooltip';
import { getProjectImages } from "../../pages/project/sections/ps-image";
import { useTranslation } from "react-i18next";
import { AppTester } from 'supporting';
import { ComputedTeam } from 'shared/helpers/types/computed/ComputedTeam';
import {ModerationType} from "../../pages/teams/const/ModerationTypes";
import {ProjectCardTitle} from "../projectCard/styles";
import { LMSCourseDurationTypes } from 'shared/pages/teams/const/LMSCourseTypes';
import { TeamStatusActiveArchived } from 'shared/helpers/teamsStatus';

const Author = styled(FInter.SmallText)`
  font-size: 11px;
  line-height: 13px;
    
  color: ${Colors.geoWhite47};
  @media (max-width: 940px) {
    div {
      font-weight: 400;
    }
  }
`

export const StatusText = styled(FlexBox)<{hasCover?: boolean}>`
  position: absolute;
  top: 16px;
  left: 16px;
  margin-right: 100%;

  color: ${({ hasCover }) => hasCover ? '#fff' : '#909090'};
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
  font-family: 'Inter';
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 13px; /* 118.182% */
  white-space: nowrap;
`;

export interface ChannelCardProps extends Partial<ComputedTeam>, ProjectEvents {
  isLoading?: boolean;
  isEditable?: boolean;
  isSelectable?: boolean;
  isDeletable?: boolean;
  isRejected?: boolean;
  isRemovableFromBook?: boolean;
  tooltip?: ProjectTooltipProps;
  width?: string;
  height?: string;
  entityType?: string;
  onShouldReload?: (sender: any) => void;
  onTeamClick?: (team: ComputedTeam, e?: any) => void;
  onSelect?: (projectId: string) => void;
  onApprove?: (projectId: string) => void;
  onReject?: (projectId: string) => void;

  team?: ComputedTeam;
 
  isModal?: boolean;
  dataKey?: any;
  linkPrefix?: string;
  linkTo?: any;
}

const ChannelCard: FC<ChannelCardProps> = (props) => {
    const {
      isLoading,
      isSelectable,
      isDeletable,
      isRemovableFromBook,
      isEditable,
      isRejected,
      tooltip,
      width,
      height,
      onApprove,
      onReject,
      onSelect,
      onShouldReload,
      onTeamClick,
      onRemoveFromBook,
      team,
      contextName,
      linkPrefix,
      linkTo,
      entityType,
      ...handlers
    } = props;

    const { i18n } = useTranslation();
    const isOnlines = AppTester.isOnlines();
    const isMedia = AppTester.isMediiia();
    const [isBookmarked, setIsBookmarked] = useState<boolean>()
    const { t } = useTranslation();
    const isMobile = useIsMobile();
    const isTimeLine = !!useRouteMatch('/timeline');

    const [isTooltipOpen, setTooltipOpen] = useState<boolean>(false);

    const handleToolTipToggleMove = (val: boolean) => {
      setTooltipOpen && setTooltipOpen(val);
    }

    const titleImages = getProjectImages(team, i18n.language);

    useEffect(() => {
      if (!team) return;
      //@ts-ignore
      setIsBookmarked(team.isBookmark);
    }, [team]);
  
    const handleTeamClick = (projectId?: string, e?: any) => {
      team && onTeamClick && onTeamClick(team, e);
    }

    const lmsCardType = useMemo(() => {

      return undefined;
    }, [team, entityType]);

    const horizontalCover = useMemo(() => {
      //@ts-ignore
      return (team?.lmsCourseTerm === LMSCourseDurationTypes.short) /*|| (isUnitCourse && team?.lmsCourseTerm === null)*/
    } , [team])
    // @ts-ignore
    const teamOwner = useMemo(() => team?.owners?.length > 0 ? `${team?.owners[0]?.name} ${team?.owners[0]?.surName}` : '', [team])
    
    const isArchiveCourseChannel = useMemo(() => {
      return team?.moderationType === ModerationType.ChannelGroupOrCourse && TeamStatusActiveArchived(team)
    } , [team])

    const backgroundStyles = useMemo(() => {
      if (isArchiveCourseChannel) {
        return {
          background: 'linear-gradient( 180deg,rgba(0, 0, 0, 0),  rgba(24, 26, 28, 0), rgba(24, 26, 28, 0.85) )',
          backdropFilter: 'blur(2.5px)',
          marginTop: 0
        }
      }
      return undefined
    } , [isArchiveCourseChannel])


    const statusText = useMemo(() => {
      if (isArchiveCourseChannel) {
        return <StatusText hasCover={!!titleImages?.length}>{t('subscription.in_archive').toLowerCase()}</StatusText>
      }
      return undefined
    } , [isArchiveCourseChannel, titleImages])

    const title = useMemo(() => {

      if (isTimeLine) return null;

      //@ts-ignore
      else if (team?.coverTitle?.length) {
        //@ts-ignore
        return <ProjectCardTitle >{team?.coverTitle}</ProjectCardTitle>
      } 
      else if (team?.name?.length) {
        return <ProjectCardTitle {...(isArchiveCourseChannel ? { color: '#909090'} : {})}>{team?.name}</ProjectCardTitle>
      } else return null;


    }, [team, isTimeLine, isArchiveCourseChannel])

    const subscribersCount = useMemo(() => team?.subscribersCount , [team])

    const likes = useMemo(() => {

      if (team?.moderationType === ModerationType.ChannelGroupOrCourse || !subscribersCount || subscribersCount === 0) return null;

      return  (
        <Author>
          <span style={{ color: isMedia && isMobile ? '#151514' :'#fefefe' }}>{`Подписчиков: ${subscribersCount}`}</span>
        </Author>
      )
    } , [team, subscribersCount])

      return (
      <ProjectCardLayoutNew
        title={title}
        coverTitle={!!team?.name ? <ProjectCardTitle>{team?.name}</ProjectCardTitle> : undefined}
        identifier={team?.teamId}
        onClick={handleTeamClick}
        titleImages={titleImages}
        isLoading={isLoading}
        width={width}
        team={team}
        height={height}
        isMoreVisible={true}
        isRejected={isRejected}
        metaAlwaysVisible={false}
        tooltipOpen={isTooltipOpen}
        toggleTooltip={handleToolTipToggleMove}
        needLmsCover={horizontalCover}
        statusText={statusText}
        isMobileMoreVisible={isArchiveCourseChannel}
        backgroundStyles={backgroundStyles}
        linkTo={linkTo}
        // @ts-ignore
        projectType={lmsCardType}
        lmsCardType={lmsCardType}
        withoutGoToProject={!linkTo}
        author={
          (
            <Author>
              {/*@ts-ignore*/}
              <span style={{ color: isMedia && isMobile ? '#151514' :'#fefefe'}}>{teamOwner}</span>
            </Author>
          )
        }
        likes={likes}
        isTeam
      />
    );
  }
;

export default memo(ChannelCard);
